'use client'
import { EmptyContent } from '@/components/common/empty-content'
import { useQueryParams } from '@/hooks'
import { Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useWishlistSync } from '../hooks/useWishlistSync'
import { ProductGrid, ProductLoading } from '@/features/products/pages/product-list/components'

export const WishlistComponent = () => {
  const t = useTranslations('Product')
  const pathname = usePathname()
  const router = useRouter()
  const searchParams = useSearchParams()
  const { createQueryString } = useQueryParams()

  // Lấy page và pageSize từ URL params
  const currentPage = parseInt(searchParams.get('page') || '1')
  const pageSize = parseInt(searchParams.get('pageSize') || '12')

  // Sử dụng hook đồng bộ
  const { wishlistData, isLoading, error, refetch } = useWishlistSync(currentPage, pageSize)
  console.log('🚀 ~ WishlistComponent ~ wishlistData:', wishlistData)

  const handleChangeFilter = (e: number | Record<any, any> | string, type: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    router.push(pathname + '?' + createQueryString(type, e?.toString()))
  }

  const handlePageChange = (page: number) => {
    handleChangeFilter(page, 'page')
  }

  if (isLoading) return <ProductLoading />

  if (error) {
    return <EmptyContent title="Chưa có sản phẩm yêu thích" />
  }

  if (!wishlistData || wishlistData?.items?.length < 1 || !wishlistData?.items) {
    return <EmptyContent title="Chưa có sản phẩm yêu thích" />
  }

  return (
    <>
      <Typography
        sx={{
          fontWeight: 500,
          mb: 2,
          textTransform: 'uppercase',
        }}
        variant="h6"
      >
        {t('wishlist')}
      </Typography>

      <ProductGrid
        direction="GRID"
        products={wishlistData}
        onPageChange={handlePageChange}
        showSetItems={false}
      />
    </>
  )
}
